import styled from "@emotion/styled";
import { useRef } from "react";
import {
  zIndex,
  fontSize,
  fontWeight,
  opacity,
  spacing,
  nav,
  text,
} from "@atlas-int/tokens";
import { logos } from "../../assets/icons";
import { CloseButton } from "@atlas-int/ui";

const NotificationContainer = styled.div`
  background-color: ${nav.background};
  opacity: ${opacity.loading};
  position: fixed;
  z-index: ${zIndex.mobileNotification};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100dvh;
  font-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 0 0 20vw;
`;

const NotificationLogo = styled.img`
  top: 0;
  height: ${spacing[20]};
  min-height: ${spacing[20]};
`;

const NotificationMessage = styled.div`
  color: ${text.onDark};
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.normal};
  width: 60vw;
  margin-top: ${spacing[8]};
  text-size-adjust: auto;
`;

const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  right: 5vw;
  top: 5vw;
  color: ${text.onDark};
  font-size: ${fontSize["2xl"]};
`;

export default function MobileNotification({
  onClose,
}: {
  onClose?: () => void;
}) {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <NotificationContainer
      ref={containerRef}
      role="dialog"
      aria-modal="true"
      aria-labelledby="mobile-notification-title"
      tabIndex={-1}
      style={{ outline: "none" }}
    >
      <div>
        <NotificationLogo
          src={logos.glLogoWhite}
          alt="Growth Lab logo"
          id="mobile-notification-title"
        />
      </div>
      <NotificationMessage>
        <p>
          The <span className="bold">Atlas of Economic Complexity</span> is an
          interactive data visualization platform that helps users explore the
          structure and dynamics of global trade and economic opportunities.
        </p>
        <p>
          <span className="italicize">
            To explore the data, please open this page in a wider browser
            window.
          </span>
        </p>
      </NotificationMessage>
      <StyledCloseButton
        onClick={onClose}
        label="Close notification"
      />
    </NotificationContainer>
  );
}
